import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpUtils } from '../utils/httpUtils';
import { ExecutionQTestEssay } from '../model/execution';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ExecutionQTestEssayService {

  readonly baseUrl = `${environment.qualificatesUrl}/executionTestEssay`;
  constructor(private http: HttpClient) {}

  getEventValue(id: number): Observable<any> {
      const url =  `${this.baseUrl}/essayValue/${id}/event`;

      return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getLethalityValue(essay: ExecutionQTestEssay): Observable<any> {
      const essaySend = _.cloneDeep(essay);

      delete essaySend.sensors;

      const url = `${this.baseUrl}/essayValue/${essaySend.id}/lethality`;

      return this.http.post(url, essaySend).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getMinMaxValue(essay: ExecutionQTestEssay): Observable<any> {
      const essaySend = _.cloneDeep(essay);

      delete essaySend.sensors;

      const url =  `${this.baseUrl}/essayValue/${essaySend.id}/minMax`;

      return this.http.post(url, essaySend).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getHotColdSpotValue(essay: ExecutionQTestEssay): Observable<any> {
      const essaySend = _.cloneDeep(essay);

      delete essaySend.sensors;

      const url = `${this.baseUrl}/essayValue/${essaySend.id}/hotColdSpot`;

      return this.http.post(url, essaySend).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  getDiffAvgValue(essay: ExecutionQTestEssay): Observable<any> {
      const essaySend = _.cloneDeep(essay);

      delete essaySend.sensors;

      const url = `${this.baseUrl}/essayValue/${essaySend.id}/diffAvgValue`;

      return this.http.post(url, essaySend).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  checkEssayDiffErrors(id: number): Observable<any> {
    const url = `${this.baseUrl}/essayValue/${id}/sensorAvg`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  checkEssayDiffAveragesErrors(id: number): Observable<any> {
    const url = `${this.baseUrl}/essayValue/${id}/diffAvaranges`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }

  checkDiffCalculateProbeWithRespectMeanErrors(id: number): Observable<any> {
    const url = `${this.baseUrl}/essayValue/${id}/diffCalculateProbeWithRespectMean`;
    return this.http.get(url).pipe(map(httpRes => HttpUtils.extractData(httpRes)));
  }
      
}
